import { IonRouterLink, IonCard, IonCardHeader, IonPage, IonContent, IonRange, IonCol, IonRow, IonSegment, IonSegmentButton, IonLabel, IonItem, IonPopover, IonInput, IonRefresher, IonRefresherContent, IonText, IonIcon } from "@ionic/react";
import { useContext, useEffect, useRef, useState, ReactNode } from "react";
import PageTitle from "../components/PageTitle";
import SearchResults from "../components/SearchResults";
import SportsDropdown from "../components/SportsDropdown";
import { Users } from "../services/api";
import { RefresherEventDetail } from '@ionic/core';
import useStateCallback from "../hooks/useStateCallback";
import useAuth from "../hooks/useAuth";
import useUser from "hooks/useUser";
import { RouteComponentProps } from "react-router";
import { usePosition } from "hooks/usePosition";
import useDynamicInputs from "hooks/useDynamicInputs";
import GenderCheckboxes from "components/GenderCheckboxes";
import styled from "styled-components";
import { caretDown, caretUp } from "ionicons/icons";
import { FilterContext } from "State/FilterContext";
import CommonHeader from "components/CommonHeader";
import Podium from '../components/Podium';
import { generateRandomString, getLinearGradient } from '../services/util';
import useLeaders from 'hooks/useLeaders';
import CenteredSpinner from 'components/CenteredSpinner';
import RankCard from 'components/RankCard';

import GroupedSearchResults from "components/GroupedSearchResults";

const LeaderboardPage: React.FC<RouteComponentProps> = ({ history }) => {
	const { leaders, leadersLoading } = useLeaders();
	console.log("Get leader list", leaders);

	const [shouldGroup, setShouldGroup] = useState<boolean>(true);

	const { token } = useAuth();
	const { user } = useUser();
	const { genders, gendersStringsToObjects } = useDynamicInputs();
	const [time, setTime] = useState<LeaderBoardTime>("all-time");
	const [distance, setDistance] = useState<number>(100);
	const [location, setLocation] = useState<string>("");
	const timeoutID = useRef<number>();
	const [zip, setZip] = useStateCallback<string>(user?.preference?.primary_address?.postal_code ?? "");
	const [selectedSports, setSelectedSports] = useState<string[]>([]);
	const [popoverState, setShowPopover] = useState(false);
	const [results, setResults] = useState<any>([]);
	const [selectedGenders, setSelectedGenders] = useState<string[]>([]);
	const { position, prompt } = usePosition();
	const [showFilters, setShowFilters] = useState<boolean>(false);
	const [age, setAge] = useState<AgeRange>({
		lower: 0,
		upper: 0
	});
	const { state, dispatch } = useContext(FilterContext);
	const [leadersCache, setLeadersCache] = useState<User[]>([]);
	const [leaderNodes, setLeaderNodes] = useState<ReactNode[]>([]);
	const [leaderLoadStatus, setleaderLoadStatus] = useState<number>(1);


	const checkGrouping = (filters: LeaderBoardFilters) => {
		if (filters['sport'] === 'all' || filters['sport'] === ''){
			setShouldGroup(true);
		} else {
			setShouldGroup(false);
		}
	}

	const getLeaders = (leaders: User[]) => {
		if (JSON.stringify(leaders) !== JSON.stringify(leadersCache)) {
			setLeadersCache(leaders);
			let newLeaderNodes = leaders.map(leader => (
				<RankCard
					key={generateRandomString()}
					user={leader}
					lines="none"
					style={{ "--background": "transparent" }}
					textColor="main"
				/>
			));
			setLeaderNodes(newLeaderNodes);
		} else {
			return leaderNodes;
		}
	}

	const checkOrigin = async (filters: any) => {
		console.log('==checkOrigin()');
		if (
			// origin not set as location string
			(filters['origin'] === null || filters['origin'] === '') &&
			// position has been aquired 
			(position?.coords?.latitude && position?.coords?.longitude)
		) {
			console.log('using browser location as origin');
			const { latitude, longitude } = position.coords;
			filters['origin'] = {
				lat: latitude,
				lon: longitude
			}
		} else if (filters['origin'] !== "" && typeof filters['origin'] === 'string') {
			console.log({ origin: filters['origin'] });
		} else {
			console.log('prompting', filters);
			let newPosition = await prompt();
			console.log('newPosition', newPosition);
			if (newPosition !== null) {
				console.log('setting new position', newPosition);
				filters['origin'] = newPosition.coords;
			} else {
				console.log('no location');
			}
		}
		return filters;
	}

	const loadLeaderboard = async (event: CustomEvent<RefresherEventDetail> | null) => {
		let filters: LeaderBoardFilters = {
			time,
			distance,
			genders: gendersStringsToObjects(selectedGenders),
			ageRange: age,
			origin: location,
			sport: 'all'
		}


		if (selectedSports.length > 0) {
			filters['sport'] = (typeof selectedSports === "object") ? selectedSports.toString() : selectedSports;
		}
		filters = await checkOrigin(filters);

		if (leaderLoadStatus == 1) {
			return;
		}
		let response = Users.getLeaders(token ?? "", filters);

		if (response) {
			response.then(function (data) {
				if (data.success) {
					setResults(data.payload);
				} else {
					console.error('failed search', data.message);
				}
				if (event) {
					event.detail.complete();
				}
			});
		}
	}

	const updateDistance = (e: any) => {
		setDistance(e.target.value);
		setleaderLoadStatus(3);
	}

	const updateAge = (e: any) => {
		setAge(e.target.value);
		setleaderLoadStatus(3);
	}

	// const updateGenderSelection = (checked: boolean, gender_change: string) => {
	// 	const newGenderArr: string[] = selectedGenders;
	// 	if (checked) {
	// 		if (newGenderArr.indexOf(gender_change) < 0) {
	// 			newGenderArr.push(gender_change);
	// 		}
	// 	} else {
	// 		const index = newGenderArr.indexOf(gender_change);
	// 		if (index > -1) {
	// 			newGenderArr.splice(index, 1);
	// 		}
	// 	}
	// 	setSelectedGenders(newGenderArr);
	// 	setleaderLoadStatus(3);
	// }


    const updateGenderSelection = (
    checked: boolean,
    gender_change: string
) => {
    setSelectedGenders(prev => {
        if (checked) {
            if (!prev.includes(gender_change)) {
                return [...prev, gender_change];
            }

            return prev;
        }

        return prev.filter(gender => gender !== gender_change);
    });

    setleaderLoadStatus(3);
};


	// load leader board with default values
	useEffect(() => {
		loadLeaderboard(null);
	}, [user, token, selectedSports, time, origin, age, selectedGenders])

	// setup polling interval to detect change to distance
	useEffect(() => {
		if (timeoutID.current) {
			clearTimeout(timeoutID.current);
		}
		timeoutID.current = window.setTimeout(function () {
			loadLeaderboard(null);
		}, 500);
		return () => clearTimeout(timeoutID.current);
	}, [distance]);

	useEffect(() => {
		setSelectedGenders(() => {
			if (genders) {
				if (genders && genders.map !== undefined) {
					return genders.map(each => each.name ?? "");
				} else {
					return [];
				}
			} else {
				return [];
			}
		})
	}, [genders])

	const show_time_filters = false;
	const use_zip_popup = false;


	console.log("Leaderload status", leaderLoadStatus);
	console.log("Result", results);
    
	return (
		<IonPage>
			<CommonHeader title={`Leaderboard`} />
			<IonContent fullscreen>
				<div>
					<FiltersSection>
						<FiltersHead onClick={() => setShowFilters(!showFilters)}>
							<FiltersTitle>Filters</FiltersTitle>
							<IonIcon slot="end" icon={(showFilters) ? caretUp : caretDown} />
						</FiltersHead>
						<FiltersBody show={showFilters}>
							{
								(show_time_filters) ? (
									<div style={{ margin: "0 var(--horizontal-gutter)" }}>
										<IonSegment
											onIonChange={e => setTime(e.detail.value as LeaderBoardTime)}
											value={time}
											mode="ios"
										>
											<IonSegmentButton value="all-time">
												<IonLabel>All Time</IonLabel>
											</IonSegmentButton>
											<IonSegmentButton value="this-month">
												<IonLabel>This Month</IonLabel>
											</IonSegmentButton>
											<IonSegmentButton value="this-week">
												<IonLabel>This Week</IonLabel>
											</IonSegmentButton>
										</IonSegment>
									</div>
								) : null
							}
							<SportsDropdown
								onChange={(e) => {
									
									setSelectedSports(e);
								}}
								selectedSports={selectedSports}
								prepend={[{
									name: "All", value: '',
									sport_type: ""
								}]}
							/>
							<IonItem>
								<IonLabel position="stacked">Location</IonLabel>
								<IonInput
									type="text"
									onIonChange={(e) => {
										let newLocation = e.detail.value;
										setLocation((typeof newLocation === 'string') ? newLocation : "");
										
									}}
									name="text"
									placeholder="City, State, or Zip Code"
									value={location}
								/>
							</IonItem>
							<IonCol style={{ padding: "var(--horizontal-gutter)" }}>
								{
									(use_zip_popup) ? (
										<IonRow style={{ padding: "var(--horizontal-gutter)" }} className="ion-justify-content-end">
											<strong>{distance}</strong>
											<span style={{ margin: '0 5px' }}>miles from</span>
											<>
												<IonPopover
													isOpen={popoverState}
													onDidDismiss={() => {
														setShowPopover(false)
														loadLeaderboard(null);
													}}
												>
													<IonItem lines="none" >
														<IonLabel position="stacked">Zip Code</IonLabel>
														<IonInput name="zip" onIonChange={(e) => setZip(e.detail.value as string, () => { })} placeholder="Enter Zip Code" />
													</IonItem>
												</IonPopover>
												<div className="zip-popover" onClick={(e) => { setShowPopover(true) }}>
													<strong><u>{(zip) ? zip : "Zip Code"}</u></strong>
												</div>
											</>
										</IonRow>
									) : null
								}
								<IonItem>
									<RowLabel position="floating">
										<IonText>Distance</IonText>
										<LabelValue>({distance} miles)</LabelValue>
									</RowLabel>
									<IonRange pin={true} dualKnobs={false} min={0} max={300} name="distance" value={distance} onIonChange={updateDistance}>
										<IonText slot="start">0</IonText>
										<IonText slot="end">300</IonText>
									</IonRange>
								</IonItem>
								<IonItem>
									<RowLabel position="floating">
										<IonText>Age</IonText>
										<LabelValue>{(age && age.lower && age.upper) ? `(${age.lower} - ${age.upper})` : null}</LabelValue>
									</RowLabel>
									<IonRange pin={true} dualKnobs={true} min={0} max={100} name="age" value={age} onIonChange={updateAge}>
										<IonText slot="start">0</IonText>
										<IonText slot="end">100</IonText>
									</IonRange>
								</IonItem>
								<GenderCheckboxes selectedGenders={selectedGenders} onChange={updateGenderSelection} />
							</IonCol>
						</FiltersBody>
					</FiltersSection>
					{
						(leaderLoadStatus == 1 || leaderLoadStatus == 2) ?
							<IonCard
								style={{ "--background": getLinearGradient('accent-two') }}
							>
								<IonRouterLink routerLink="/leaderboard">
									<IonCardHeader>
										<div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between' }}>
											<TileTitle color="main" style={{ fontSize: '30px' }}>Leaderboard</TileTitle>
											<Podium height={45} width={17} />
										</div>
									</IonCardHeader>
								</IonRouterLink>
								{(leadersLoading) ? <CenteredSpinner /> :
									(leaders && leaders.length && leaders.length > 0) ? getLeaders(leaders) : null
								}
							</IonCard>

							: null
					}

				</div>
				<IonRefresher slot="fixed" onIonRefresh={loadLeaderboard}>
					<IonRefresherContent>
					</IonRefresherContent>
				</IonRefresher>
				
				{/* {(leaderLoadStatus == 3) ? 
					<SearchResults results={results} filters={{
						time,
						distance,
						genders: selectedGenders,
						ageRange: age,
						origin,
						sport: (selectedSports.length > 0) ? selectedSports[0] : null,
					}} searchType="leaderboard" />
				: null
				} */}


				 {
					(leaderLoadStatus == 3) ? 
				(() => {
					let filters = {
						//time: state.leaderboardFilters.ageRange,
						time,
						distance: state.leaderboardFilters.distance,
						genders: state.leaderboardFilters.genders,
						//ageRange: state.leaderboardFilters.ageRange,
                        ageRange: age,
						origin,
						sport: state.leaderboardFilters.sport
					}
					return (shouldGroup) ? (
						<GroupedSearchResults results={results} filters={filters} searchType="leaderboard" />
					):(
						<SearchResults results={results} filters={filters} searchType="leaderboard" />
					);
				})()
				: null
				}
				

			</IonContent>
		</IonPage>
	)
}

export default LeaderboardPage;

const FiltersSection = styled.div`
	
`;

const FiltersHead = styled(IonItem)`
	justify-content: space-between;
`;

const FiltersTitle = styled.div`
	font-size: 20px;
`;

const FiltersBody = styled.div<{ show: boolean }>`
	display: ${props => (props.show) ? "block" : "none"}
`;

const RowLabel = styled(IonLabel)`
	display: flex !important;
	justify-content: space-between;
	width: 100%;
`;

const LabelValue = styled(IonText)`
	margin-left: 10px;
	font-size: 12px;
`;
const TileTitle = styled.div`
	font-size: 15px;
	font-family: var(--heading-font);
	color: black;
`;
